import { supabase } from '@/lib/supabase/client';
import { reportError } from '@/lib/errors';
import { buildProfileOnboardingUpdate } from '@/lib/supabase/profile-mappers';
import type { OnboardingStep } from './steps';

/**
 * Persist the onboarding resume pointer (`profiles.onboarding_step`) for the
 * given user. The redesigned onboarding screens call this on each advance so a
 * returning/relaunching user resumes at their last step instead of restarting.
 *
 * Fire-and-forget: failures are reported but never block navigation — a missed
 * pointer write only costs the user a resume, it must not trap them on a screen.
 * Get `userId` from `useAuth().user.id` at the call site (the canonical uid
 * source); this helper stays pure of React/auth context so it is unit-testable.
 */
export async function persistOnboardingStep(userId: string, step: OnboardingStep): Promise<void> {
  try {
    await (supabase.from('profiles') as any)
      .update(buildProfileOnboardingUpdate(step, false))
      .eq('id', userId);
  } catch (err) {
    reportError(err, { context: 'onboarding.persistOnboardingStep', level: 'warning' });
  }
}
